var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeMenuIcon9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    "data-name": "\\u5716\\u5C64 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.16 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0610_\u5F8C\u53F0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.27,6.54a.55.55,0,0,0-.39-.16.55.55,0,1,0,0,1.1.55.55,0,0,0,.39-.16.56.56,0,0,0,0-.78Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.41,6.38H21.9a.55.55,0,0,0,0,1.1h3.51a1.65,1.65,0,0,1,1.65,1.65v7.92a1.65,1.65,0,0,1-1.65,1.65h-.77a.55.55,0,0,0-.39.16l-1.81,1.81-1.81-1.81a.59.59,0,0,0-.39-.16H13a1.65,1.65,0,0,1-1.65-1.65v-2a.55.55,0,0,0-.55-.55.55.55,0,0,0-.55.55v2A2.75,2.75,0,0,0,13,19.8h7l2,2a.56.56,0,0,0,.78,0l2-2h.54a2.75,2.75,0,0,0,2.75-2.75V9.13A2.75,2.75,0,0,0,25.41,6.38Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.18,0H2.75A2.75,2.75,0,0,0,0,2.75v7.92a2.75,2.75,0,0,0,2.75,2.75H3.91l2,2a.56.56,0,0,0,.78,0l2-2h6.42a2.75,2.75,0,0,0,2.75-2.75V2.75A2.75,2.75,0,0,0,15.18,0Zm1.65,10.67a1.65,1.65,0,0,1-1.65,1.65H8.53a.59.59,0,0,0-.39.16L6.33,14.29,4.52,12.48a.55.55,0,0,0-.39-.16H2.75A1.65,1.65,0,0,1,1.1,10.67V2.75A1.65,1.65,0,0,1,2.75,1.1H15.18a1.65,1.65,0,0,1,1.65,1.65Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.34,15.19l-1.95-4.62a.55.55,0,0,0-1,0l-1.95,4.62a.55.55,0,1,0,1,.42l.27-.65h2.34l.27.65a.56.56,0,0,0,.51.34.57.57,0,0,0,.22,0A.55.55,0,0,0,22.34,15.19Zm-3.16-1.33.7-1.67.7,1.67Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.52,8.63,11,8.25a2.54,2.54,0,0,0,.25-1.1V6.27a2.53,2.53,0,0,0-5.06,0v.88A2.53,2.53,0,0,0,8.72,9.68a2.47,2.47,0,0,0,1.59-.57l.56.41a.54.54,0,0,0,.32.11.55.55,0,0,0,.33-1ZM10.15,7.15a1.42,1.42,0,0,1-.07.42L9.5,7.15A.55.55,0,1,0,8.85,8l.52.39A1.42,1.42,0,0,1,7.29,7.15V6.27h0a1.43,1.43,0,0,1,2.86,0v.88Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMenuIcon9);
export default __webpack_public_path__ + "static/media/homeMenuIcon9.55e529614effaadc7cc8b7041d6d3989.svg";
export { ForwardRef as ReactComponent };